
export class CalculatorLifecycle {
  private initialized: boolean = false;
  private stylesReady: boolean = false;
  private renderTimeout: number | null = null;
  
  isInitialized(): boolean {
    return this.initialized;
  }
  
  setInitialized(value: boolean): void {
    this.initialized = value;
  }
  
  isStylesReady(): boolean {
    return this.stylesReady;
  }
  
  setStylesReady(value: boolean): void {
    this.stylesReady = value;
  }
  
  getRenderTimeout(): number | null {
    return this.renderTimeout;
  }
  
  setRenderTimeout(timeout: number | null): void {
    if (this.renderTimeout !== null) {
      clearTimeout(this.renderTimeout);
    }
    this.renderTimeout = timeout;
  }
  
  cleanup(): void {
    if (this.renderTimeout !== null) {
      clearTimeout(this.renderTimeout);
      this.renderTimeout = null;
    }
    this.initialized = false;
    this.stylesReady = false;
  }
}
